import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import TimeOffType from './TimeOffType';
import {Employee} from 'main/stores/employees';
import {dateSpan} from 'shared/tools';
import _ from 'lodash';

class TimeOffBlockedDates extends DomainObject {
  name;
  startDate;
  endDate;
  employees = [];
  types = [];

  _relations = {
    _dates: ['startDate', 'endDate'],
    types: [TimeOffType],
    employees: [Employee]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      startDate: observable,
      endDate: observable,
      employees: observable,
      types: observable,
      typeNames: computed,
      dateRange: computed
    });

    this.merge(other);
  }

  get typeNames() {
    return _.map(this.types, 'name').join(', ');
  }

  get dateRange() {
    return dateSpan(this.startDate, this.endDate, true);
  }
}

export default TimeOffBlockedDates;
